import GoogleAdBlock from "../atoms/GoogleAdBlock"
import { usePluginConfig } from "../../contexts/pluginContext"
import EventDetailsPromotionalAsset from "../atoms/EventDetailsPromotionalAsset"

const EventDetailsAd = () => {
  const pluginConfig = usePluginConfig();
  const publisher = pluginConfig.publisherSettings.publisher;

  return <EventDetailsPromotionalAsset
      utmSource={publisher.id}
      utmMedium="event_details"
      utmCampaign="promote_asset"
    />
}

export default EventDetailsAd;
